import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  technology: z.enum(["Ultrasonic","Nebulizing","Heat"]).optional(),
  coverage_m2: z.number().int().positive().optional(),
  tank_ml: z.number().int().positive().optional(),
  timer: z.boolean().optional(),
  power_source: z.enum(["Mains","USB","Battery"]).optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "home-office-diffusers", slug: "home-aroma",
    name: "Home Aroma",
    tagline: "Electric and nebulizing diffusion", status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name","notes"], attributes: ["technology"] },
  facets: [
    { key: "technology", label: "Technology", type: "enum", source: "attribute",
      options: ["Ultrasonic","Nebulizing","Heat"] },
    { key: "power_source", label: "Power", type: "enum", source: "attribute",
      options: ["Mains","USB","Battery"] },
    { key: "coverage_m2", label: "Coverage (m2)", type: "range", source: "attribute",
      min: 5, max: 200, step: 5, unit: "m2" },
    { key: "timer", label: "Timer", type: "boolean", source: "attribute" },
    { key: "price", label: "Price (₹)", type: "range", source: "column",
      min: 50, max: 800, step: 10, unit: "₹" },
  ],
  pdpPanels: [
    { key: "specs", label: "Device specifications", attributes: ["technology","coverage_m2","tank_ml","power_source","timer"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Aroma Diffuser",
    descriptionTemplate: "{name} — aroma diffuser for home and office.",
    routePrefix: "home-office-diffusers",
  },
  adminForm: [
    { key: "technology", label: "Technology", kind: "select", options: ["Ultrasonic","Nebulizing","Heat"] },
    { key: "coverage_m2", label: "Coverage (m2)", kind: "number" },
    { key: "tank_ml", label: "Tank (ml)", kind: "number" },
    { key: "power_source", label: "Power source", kind: "select", options: ["Mains","USB","Battery"] },
    { key: "timer", label: "Timer", kind: "boolean" },
  ],
};
